module.exports = __webpack_public_path__ + "img/vegetable-morels-190x100.d756704c.jpg";